import { useMemo } from 'react';
import type { OrganizationClientsBase } from './useOrganizationClients';

export function useSyncStatus({ clientsForTable }: OrganizationClientsBase) {
  const recentClients = useMemo(() => {
    if (!clientsForTable) return undefined;
    return [...clientsForTable]
      .filter(c => c.last_viewed_at)
      .sort((a, b) => new Date(b.last_viewed_at!).getTime() - new Date(a.last_viewed_at!).getTime())
      .slice(0, 20);
  }, [clientsForTable]);

  return { recentClients };
}
